import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {GuiZoneFormComponent} from '@catmodules/models/gui-zone/components/gui-zone-form/gui-zone-form.component';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';
import { DeleteGuiZoneComponent } from './components/delete-gui-zone/delete-gui-zone.component';
import { AddGuiZoneComponent } from './components/add-gui-zone/add-gui-zone.component';

const publicComponents = [
  GuiZoneFormComponent,
  DeleteGuiZoneComponent,
  AddGuiZoneComponent,
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIBaseModule,
  UIFormModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class GuiZoneModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/gui-zone/gui-zone.module.ts